import { render, staticRenderFns } from "./IconFlagEnd.vue?vue&type=template&id=5e54d74b"
import script from "./IconFlagEnd.vue?vue&type=script&lang=js"
export * from "./IconFlagEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports